// Components
import { useRecoilValue } from "recoil";
import { cifTypeState, geoState, selPOICategories } from "../../states";
import { Heading, TypographyType, TypographyColor, Body, BodyType, BodyColor, ProgressBar, InfoPanel } from "../../ui-elements"

// Utilities
import { GOOGLE_ICON_MAP } from "../../constants";
import { getPoiIconColor } from "../../helpers";
import * as Constants from '../../utils/constants/Constants';
import { useRef } from "react";
import { useActivateTooltip } from "../../helpers/useActivateTooltip";

interface POIInfoProps {
    poi: any;
    isPoIToggled: boolean
}

interface POICategoryItemProps {
    cat: any;
    category: number[];
    isPoIToggled: boolean;
    cifType: any;
}

const POICategoryItem = ({ cat, category, isPoIToggled, cifType }: POICategoryItemProps) => {
    const textRef = useRef<HTMLDivElement>(null);
    const showTooltip = useActivateTooltip(textRef);

    return (
        <div key={cat.key} className="col-6 d-flex justify-content-start align-items-center p-0 m-0 padding-top-bottom-3">
            <div className={`d-flex justify-content-center align-items-center rounded-circle square-icon-box text-center ${getPoiIconColor(cifType, category, cat.key)}`}>
                <span className="material-symbols-outlined fs-20">{GOOGLE_ICON_MAP.get(cat.key)}</span>
            </div>
            <div className="single-poi-info-card padding-left-3 position-relative w-75">
                <Heading
                    title={cat.display != null ? cat.display : '--'}
                    type={TypographyType.h4}
                    colour={TypographyColor.primary}
                    classname='text-start p-0'
                />
                <div
                    ref={textRef}
                    title={showTooltip ? cat.catName : undefined}
                    className={`p-0 text-truncate text-start max-w-95 fs-14 ${category.includes(cat.key) && isPoIToggled ? 'color-blue' : 'color-secondary'}`}
                >
                    {cat.catName}
                </div>
            </div>
        </div>
    );
};

export const POIInfo: React.FC<POIInfoProps> = ({ poi, isPoIToggled }) => {
    const cifType = useRecoilValue(cifTypeState);
    const selectedGeo = useRecoilValue(geoState);
    const { category } = useRecoilValue(selPOICategories);


    return (
        <div className="row p-0 m-0 padding-top-5 padding-bottom-0 padding-left-right-5">
            <div className="col-12 m-0 p-0">
                <Heading
                    title={`${poi?.Poi?.display}${poi?.Poi?.overlap ? ' *' : ''}` || '--'}
                    type={TypographyType.h4}
                    colour={TypographyColor.primary}
                    classname='text-start text-truncate p-0'
                />
                <div className="col-12 d-flex justify-content-start align-items-center">
                    <Body
                        type={BodyType.p2}
                        color={BodyColor.secondary}
                        classname="p-0 d-flex flex-row align-items-center"
                    >
                        “High EH, High CTV” Points of Interest (<b>PoI</b>)
                    </Body>
                    <InfoPanel text={Constants.iButtonText.homePage.cif.pointsOfInterest} classname='color-black-7 fs-14 margin-left-3' />
                </div>
                {poi?.Poi?.overlap &&
                    <Body
                        type={BodyType.p3}
                        color={BodyColor.primary}
                        classname="p-0 padding-top-2 fs-9 italics"
                    >
                        * PoIs are only partially covered for this `{ selectedGeo?.village ? "Village" :  "PIN Code"}
                    </Body>
                }
            </div>
            <div className="col-12 m-0 p-0 padding-top-4">
                {!selectedGeo.district &&
                    <>
                        <div className="col-12 d-flex justify-content-start align-items-center p-0 padding-bottom-3 m-0">
                            <Heading
                                title={`${poi?.Poi?.districtCoverage?.coverage}/${poi?.Poi?.districtCoverage?.total}`}
                                type={TypographyType.h5}
                                colour={TypographyColor.primary}
                                classname='text-start p-0 padding-right-1'
                            />
                            <Body
                                type={BodyType.p2}
                                color={BodyColor.secondary}
                                classname="p-0"
                            >
                                {`Districts Covered`}
                            </Body>
                        </div>
                        <ProgressBar coverage={poi?.Poi?.districtCoverage} classname={`${isPoIToggled ? 'bg-white' : 'bg-poi'} margin-bottom-3`} />
                    </>
                }
                <div className="col-12 row p-0 m-0">
                    {poi?.catData?.map((cat: any) => (
                        <POICategoryItem
                            key={cat.key}
                            cat={cat}
                            category={category}
                            isPoIToggled={isPoIToggled}
                            cifType={cifType}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}